import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/BYD_Showroom.webp';

const Project_nine = () => {

  return (
    <>
       
             <div className='project_1_work' id="workBanner">
       
               <div className="container project_our_work">
       
                 <div className="heading">
                   <h1>BYD Showroom</h1>
                 </div>
       
                 <hr></hr>
                 <div className='project_section'>
                   <div className="project_section_content">
                     <h1 className="project_scope">Scope of Work</h1>
                     <p>A flagship automotive showroom for BYD — China's leading electric vehicle manufacturer and one of the world's top EV
                        brands by sales volume. The showroom features a premium, technology-forward environment in keeping with BYD's global
                        brand standards.</p>
                     <p>MAIN CONTRACTOR : -</p>
                     <p>MEP CONTRACTOR : Al Futtaim Engineering</p>
                     <p>GEMCO SCOPE OF WORKS : Electrical works</p>
                     {/* <h2 className="project_years">2014 – 2022</h2> */}
                   </div>
                   <div className='project_1_card'>
                     <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
                   </div>
                 </div>
               </div>
             </div>
       
           </>

  )
}

export default Project_nine